import { useContext, useEffect, useRef, useState } from 'react';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import useSmartState from '../../../common/hooks/useSmartState';
import { getStudentImage } from '../../../common/styles/Images';
import InitialsAvatar, { hasProfilePicture } from '../../../library/SimpleControls/InitialsAvatar';
import { SmartContext } from '../../../library/Core/SmartContext';
import { formatFullName, getDomainValueForCode, isEmpty, handleCopyText, getFlexColDomainValueForCode, evaluateExpression, getDateDDMMYYYY } from '../../../library/Core/SmartFunctions';
import { FormControl, FormSection } from '../../../library/Core/SmartTypes';
import ActionSettings from '../../../library/SimpleControls/ActionSettings';
import ExportToExcel from '../../../library/SimpleControls/ExportToExcel';
import InternalAdminReportService from './InternalAdminReportService';
import RowColumnBuilder from './RowColumnBuilder';
import { REPORT_CONFIG } from './report-config';
import useInternalAdminReports from './useInternalAdminReports';
import { axiosClient } from '../../../library/Service/axiosClient';
import { confirmDeleteAlumniInstitute } from '../../../library/Service/confirmDeleteAlumniInstitute';
import SessionContext from '../../../library/Core/SessionContext';
import ProfileMarkerService from '../../alumni/alumni-profile/sections/admin/ProfileMarker/ProfileMakerService';
import ViewProfileMarkersLogs from '../../alumni/alumni-profile/sections/admin/ProfileMarker/viewProfileMarkersLogs';
import axios from 'axios';
import ExportToExcelCommon from '../../../library/SimpleControls/ExportToExcelCommon';
import GrievanceDetailPopUp from '../grievance/GrievanceDetailPopUp';

const BATCH_SIZE = 10;

const Results = () => {
    const { state, dispatch } = useContext(SmartContext);
    const allRowsData = state.data.alumniList ?? [];
    console.log("allRowsData",allRowsData)
    const [bulkAction, setBulkAction] = useState<string>('' as any);
    const { setStateValue } = useSmartState();
    const [selectedRows, setSelectedRows] = useState<string[]>([]);
    const { getFormattedDate, activateAlumni, deactivateAlumni, validateAlumni, verifyEmail, deleteUser, markAsDeceased } = useInternalAdminReports();
    const resultsFormConfig = state.formConfig?.sectionRepository[1] as FormSection;
    const config = REPORT_CONFIG[state.routeInfo.pageName];
    const loadMoreRef = useRef(null);
    const [pageData, setPageData] = useState([] as any[]);
    const getActionLabel = (code: string) => code.toLowerCase().replace(/_/g, ' ');
    const navigate = useNavigate();
    const { sessionState } = useContext(SessionContext);
    const [grievanceDetailId,setGrievanceDetailId] = useState<any>(null);
    const {handleOpenLogsModal } = ProfileMarkerService();

    const handleSelectRow = (event: any) => {
        if (event.target.checked) setSelectedRows((prev) => [...prev, event.target.value]);
        else setSelectedRows((prev) => prev.filter((id) => id !== event.target.value));
    };

    const handleSelectAll = (event: any) => {
        const students = event.target.checked ? allRowsData.map((item: any) => item.uuid) : [];
        setSelectedRows(students);
    };

    const getTagline = (row: any) => {
        if (!isEmpty(row.passOutYear)) {
            return `${row.programName} - ${row.passOutYear}`;
        } else if (!isEmpty(row.programName)) {
            return `${row.programName}`;
        } else {
            return '';
        }
    };

    useEffect(() => {
        setPageData([...allRowsData.slice(0, BATCH_SIZE)]);
    }, [state.data.alumniList]);

    useEffect(() => {
        const loadMoreObserver = new IntersectionObserver((entries) => {
            if (allRowsData.length <= pageData.length) {
                if (loadMoreRef.current) loadMoreObserver.unobserve(loadMoreRef.current);
                return;
            }

            if (entries[0].isIntersecting) {
                const nextBatch = allRowsData.slice(0, pageData.length + BATCH_SIZE);
                setPageData([...nextBatch]);
            }
        });

        if (loadMoreRef.current) loadMoreObserver.observe(loadMoreRef.current);

        return () => {
            if (loadMoreRef.current) {
                loadMoreObserver.unobserve(loadMoreRef.current);
            }
        };
    }, [loadMoreRef, pageData]);


    const getDetailPopupButton = (row: any, control: any) => {
        let url: any;
        let displayValue = row[control.id];
        let customFunction: any = () => {};
        let params:any = []
        switch (control.id) {
            case 'grievanceCode':
                // url = `/grievance/view/${row.grievanceCode}`;
                customFunction = handleGrievancePopup
                params = [row]
                break;
        }

        return (
            <a href="javascript:void(0)" className="tablink blue-link p-0" onClick={() => customFunction(...params)}>
                {displayValue}
            </a>
        );
    }

    const handleGrievancePopup = (data: any) => {
        console.log(data,'data');
        setGrievanceDetailId(data.id);
        
        dispatch({ type: 'TOGGLE_MODAL_VISIBILITY', payload: { modalName: 'grievanceDetailPopup' } });

        dispatch({
            type: 'SET_MODAL_DATA',
            payload: {
                title: 'Grievance Details',
                // data: [resultsFormConfig.controlGroup.map((field: FormControl) => { return getFieldNode(field, data); })],
                data: [data],
            },
        });
    }

    const hasSearchCriteria = () =>
        Object.values(state.data.searchCriteria).some(
            (value) => (Array.isArray(value) && value.length > 0) || (!Array.isArray(value) && value !== null && value !== undefined && value !== '')
        );


    const getNoDataMessage = (state: any) => {
        let noDataMessage = 'No Data Found..!';
        let noDataSubMessage = '';
        console.log("hasSearchCriteria: ", hasSearchCriteria())
        if (hasSearchCriteria()) {
            noDataSubMessage = 'No records match your current filters. Try adjusting your search criteria.';
        }

        switch (state.routeInfo.pageName) {
            case 'inst-admin-grievance':
                if (hasSearchCriteria()) {
                    noDataSubMessage = "No grievances match your current filters. Try adjusting your search criteria."
                } else {
                    noDataSubMessage = "Click 'Add New Grievance' to get started."
                }
                break;
        }

        return [noDataMessage, noDataSubMessage];
    }
    const [noDataMessage, noDataSubMessage] = getNoDataMessage(state)


    const getGrievanceUserNameField = (row: any) => {
        return (
            <div className="d-flex align-items-center checkoption">
                {row.uuid ? (
                    <a
                        className="tablink blue-link"
                        href={`/alumni/${row.uuid}/profile`}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <i className="me-2 position-relative">
                            <img src={getStudentImage(row)} className="rounded-circle img-fluid" width="40" />
                        </i>
                        <span
                            data-bs-toggle="tooltip"
                            title={`${formatFullName(row.grievanceUserName, '')}`}
                            className="singlelinename font-16 lineHeight-16 smart-tooltip"
                        >
                            {formatFullName(row.grievanceUserName, '')}
                            <span className="d-block font-13 fst-italic"> {getTagline(row)} </span>
                        </span>
                    </a>
                ) : <>
                        <i className="me-2 position-relative">
                            <img src={getStudentImage(row)} className="rounded-circle img-fluid" width="40" />
                        </i>
                        <span
                            data-bs-toggle="tooltip"
                            title={`${formatFullName(row.grievanceUserName, '')}`}
                            className="singlelinename font-16 lineHeight-16 smart-tooltip"
                        >
                            {formatFullName(row.grievanceUserName, '')}
                            <span className="d-block font-13 fst-italic"> {getTagline(row)} </span>
                        </span>
                    </>
                }
                
            </div>
        )
    }

    const getGrievanceHMLField = (row: any, control: any) => {
        const value = row[control.id];
        let displayValue = value;
        if (control.props?.domainCategoryCode?.length > 0)
            displayValue = getDomainValueForCode(row[control.id], control.props.domainCategoryCode, state);
        let content;

        const getColorClasses = (value: string) => {
            if (!value) {
                return ['#e5e7eb', '#6b7280'];
            }
            switch (value.toLowerCase()) {
                // Priority Colors
                case 'high':
                    return ['#fee2e2', '#dc2626'];
                case 'medium':
                    return ['#fed7aa', '#ea580c'];
                case 'low':
                    return ['#e5e7eb', '#6b7280'];

                // Status Colors
                case 'new':
                    return ['#cff4fc', '#2680EB'];
                case 'acknowledged':
                    return ['#fef3c7', '#d97706'];
                case 'inprogress':
                    return ['#cffafe', '#0891b2'];
                case 'resolved':
                    return ['#d1fae5', '#059669'];
                case 'discarded':
                case 'closed':
                    return ['#e5e7eb', '#6b7280'];

                default:
                    return ['#e5e7eb', '#6b7280'];
            }
        }
        const [bgColor, textColor] = getColorClasses(value);

        content = (
            <span className={`badge rounded-pill bg-opacity-50 font-14 font-500 px-3 py-2 max-80 w-100`} style={{ backgroundColor: bgColor, color: textColor }}>
                {displayValue}
            </span>
        );
        return content;
    }

    const uuidCountMap = allRowsData.reduce((acc: any, item: any) => {
    acc[item.uuid] = (acc[item.uuid] || 0) + 1;
            return acc;
     }, {});

    const hasMultipleInstitutes = (uuid: string) => { return uuidCountMap[uuid] > 1;};

    const getAlumniNameField = (row: any) => {
        return (
            // <div className="d-flex align-items-center checkoption">
            //     {config['SHOW_SELECT_ALL'] && (
            //         <input
            //             className="form-check-input me-2 StudentId"
            //             name="uuid"
            //             type="checkbox"
            //             value={row.uuid}
            //             checked={selectedRows.includes(row.uuid)}
            //             onChange={handleSelectRow}
            //         />
            //     )}
            //     <a
            //         className="tablink"
            // href={`/alumni/${row.uuid}/profile`}
            // // href={`/${row?.userTypeCode?.toLowerCase()}/${row.uuid}/profile`}
            // // href={`/sso/${sessionState?.userHash}/cHJvZmlsZQ==/${row.uuid}`}
            //         target="_blank"
            //         rel="noopener noreferrer">
            //         <i className="me-2 position-relative">
            //             <img src={getStudentImage(row)} className="rounded-circle img-fluid" width="30" />
            //             {/* {showStar(row) && <i className="icon-star circle-img"></i>} */}
            //         </i>
            //         <span
            //             data-bs-toggle="tooltip"
            //             title={`${formatFullName(row.firstName, row.lastName)}`}
            //             className="singlelinename font-16 lineHeight-16">
            //             {formatFullName(row.firstName, row.lastName)}
            //             <span className="d-block font-13 fst-italic"> {getTagline(row)} </span>
            //         </span>
            //     </a>

            //     <div className='copyId d-flex align-items-center mt-1'>
            //         <span className="font-13 fst-italic singlelinename me-1"> {row.uuid} </span>
            //         <button id={`uuid-${row.uuid}`} className='copy-text border-0 bg-transparent' title='click to copy id'   onClick={() => handleCopyText(row.uuid, `uuid-${row.uuid}`)}>
            //         <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-copy" viewBox="0 0 16 16">
            //         <path fill-rule="evenodd" d="M4 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zM2 5a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1h1v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h1v1z"/>
            //         </svg>
            //         </button>
            //     </div>
            // </div>

            <div className="d-flex flex-column checkoption">
                <div className='w-100'>
                    <div className='row g-2 align-items-center'>
                        <div className='col-auto'>
                            <a
                    className="tablink"
                    // href={`/alumni/${row.uuid}/profile`}
                    href={
                        state.routeInfo.pageName === 'internal-admin-profile-marker' &&
                        hasMultipleInstitutes(row.uuid)
                            ? `/alumni/${row.uuid}/select-institute/${row.schoolId}/office-usage`
                            : `/alumni/${row.uuid}/profile`
                    }
                    // href={`/${row?.userTypeCode?.toLowerCase()}/${row.uuid}/profile`}
                    // href={`/sso/${sessionStorage.getItem('user-hash')}/cHJvZmlsZQ==/${row.uuid}`}
                    target="_blank"
                    rel="noopener noreferrer">
                    <i className="me-2 position-relative">
                        {hasProfilePicture(row.profilePictureFilePath) ? (
                            <img src={getStudentImage(row)} className="rounded-circle img-fluid" width="30" />
                        ) : (
                            <InitialsAvatar firstName={row.firstName} lastName={row.lastName} size={30} />
                        )}
                        {showStar(row) && <i className="icon-star circle-img"></i>}
                    </i>
                    <span
                        data-bs-toggle="tooltip"
                        title={`${formatFullName(row.firstName, row.lastName)}`}
                        className="singlelinename font-16 lineHeight-16">
                        {formatFullName(row.firstName, row.lastName)}
                        <span className="d-block font-13 fst-italic"> {getTagline(row)} </span>
                    </span>
                </a>
                        </div>
                        {Number(row.isDeceased) === 1 && (
                        <div className='col-auto'>
                            <span className="bg-gray-EFEFEF font-13 font-500 rounded px-2 py-1 text-nowrap bg-warning bg-opacity-25 border border-warning border-opacity-25 rounded-pill">In remembrance</span>
                        </div>
                        )}
                    </div>
                </div>
                {config['SHOW_SELECT_ALL'] && (
                    <input
                        className="form-check-input me-2 StudentId"
                        name="uuid"
                        type="checkbox"
                        value={row.uuid}
                        checked={selectedRows.includes(row.uuid)}
                        onChange={handleSelectRow}
                    />
                )}
                
                <div className="copyId d-flex align-items-center mt-1">
                    <span className="font-13 fst-italic singlelinename me-1"> {row.uuid} </span>
                    <button
                        id={`uuid-${row.uuid}`}
                        className="copy-text border-0 bg-transparent"
                        title="click to copy id"
                        onClick={() => handleCopyText(row.uuid, `uuid-${row.uuid}`)}>
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="currentColor"
                            className="bi bi-copy"
                            viewBox="0 0 16 16">
                            <path
                                fill-rule="evenodd"
                                d="M4 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zM2 5a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1h1v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h1v1z"
                            />
                        </svg>
                    </button>
                </div>
            </div>
        );
    };

    const getShortenedSchoolName = (row: any): any => {

        if (!row?.schoolName || typeof row.schoolName !== 'string') {
            // Gracefully handle missing/invalid schoolName
            return <span style={{ color: 'gray' }}>N/A</span>;
        }
        const parts = row?.schoolName.split(',');
        const schoolNameContent =
            parts.length > 1 ? (
                <>
                    <span>
                        {parts[0]},<br />
                        {parts.slice(1).join(',').trim()}
                    </span>
                </>
            ) : (
                <>{row.schoolName}</>
            );

        if (state.routeInfo.pageName === 'internal-admin-all-school-summary') {
            return (
                <a className="tablink" href={`/support/all-alumni-report/${row.schoolId}`} target="_blank" rel="noopener noreferrer">
                    {schoolNameContent}
                </a>
            );
        }

         if (state.routeInfo.pageName === 'internal-admin-all-school-statistics') {
            return (
                    <a
                        className="tablink d-flex align-items-center gap-2"
                        href={`/support/school-statistics/${row.schoolId}`}
                        target="_blank"
                        rel="noopener noreferrer">
                        <b className="me-2 position-relative ratio-90 d-flex align-items-center justify-content-center">
                            <img src={row.logo} className="img-fluid object-fit-cover" width={90}  />
                        </b>
                        <span
                            data-bs-toggle="tooltip"
                            title={row.schoolName}
                            className="font-16 lineHeight-16">{schoolNameContent}
                        </span></a>
                );
        }
        // If condition is not satisfied, display just the school name text
        return schoolNameContent;
    };

    const getUserEnteredInfo = (nonStandardType: string, nonStandardInfoJson: string) => {
        const nonStandardInfo = JSON.parse(nonStandardInfoJson);
        const content = nonStandardInfo
            ?.filter((item: any) => item?.nonStandardType === nonStandardType)
            ?.map((item: any, index: number) => (
                <span key={`${nonStandardType}-${index}`}>
                    {item?.type}: {item?.freeFormText}
                    <br />
                </span>
            ));
        return content;
    };

    const getActionNode = (control: FormControl, row: any) => {
        const actions = config['ROW_ACTION'].filter((action: any) => {
            let flag = true;
            if (row.isPeerReviewed == 1 && action === 'VALIDATE') flag = false;
            if (row.isEmailVerified === 1 && action === 'VERIFY_EMAIL') flag = false;
            // if (row.userStatusCode === 'ACTIVE' && action === 'ACTIVATE') return false;
            if (row.userStatusCode !== 'INACTIVE' && action === 'ACTIVATE') flag = false;
            if (row.userStatusCode === 'INACTIVE' && action === 'DEACTIVATE') flag = false;
            if(action == 'UPDATE') flag = false;
            if(row.userStatusCode == 'RAW_PROFILE') flag = action == 'UPDATE' ? true : false;
            if(row.isEngagementDataPresent != 1 && action == 'ENGAGEMENT_API_RUN' ) flag= false
            return flag;
        });

        return actions.length > 1 ? (
            <ActionSettings id={row} actions={actions} onClick={handleAction} />
        ) : (
            <a className="btn-update" href={config['UPDATE_ACTION_LINK'](row.uuid, row.schoolId)} target="_blank" rel="noopener noreferrer">
                Update
            </a>
        );
    };

    const handleAction = (uuid: string, action: string) => {
        console.log(uuid);
        handlePerformAction(action, [uuid]);
    };

    const getSchoolCountsWithLink = (columnName: string, row: any) => (
        <a
            className="tablink"
            href={`/support/all-alumni-report/${columnName === 'total' ? row.schoolId : row.schoolId + '/' + columnName}`}
            target="_blank"
            rel="noopener noreferrer">
            {row[columnName]}
        </a>
    );

    const getFieldNode = (control: FormControl, row: any) => {
        let content;
        if (evaluateExpression(control?.hideExpression, {...state?.data, userTypeCode: sessionState?.userTypeCode})) return <></>;
        const getPresentStatusPart = (row: any) => (
            <div key={row.uuid+''+row?.schoolId} className="d-flex flex-column">
                <span>
                    Education status - <b>{getDomainValueForCode(row.presentEducationStatusCode, 'PRESENT_EDUCATION_STATUS_CODE', state) ?? ''}</b>
                </span>
                <span>
                    Working status - <b>{getDomainValueForCode(row.workingStatusCode, 'WORK_STATUS_CODE', state) ?? ''}</b>
                </span>
                 <span>
                    Profile Completion - <b>  {row.profileCompletionPercentage < 40
                                    ? 'Less than 40%'
                                    : row.profileCompletionPercentage > 95
                                    ? 'More than 95%'
                                    : `${row.profileCompletionPercentage}%`}</b>
                </span>
            </div>
        );

        switch (control.id) {
            case 'grievanceCode':
                content = getDetailPopupButton(row, control);
                break;
            case 'grievancePriority':
            case 'grievanceStatus':
                content = getGrievanceHMLField(row, control);
                break;
            case 'grievanceUserName':
                content = getGrievanceUserNameField(row);
                break;
            case 'alumniName':
                content = getAlumniNameField(row);
                break;
            case 'schoolName':
                content = getShortenedSchoolName(row);
                break;
            case 'presentStatusNew':
                content = getPresentStatusPart(row);
                break;
            case 'level':
                content = getDomainValueForCode(
                    row.level == null || row.level === '' ? '' : (typeof row.level === 'number' ? `L${row.level}` : String(row.level).toUpperCase()),
                    control.props.domainCategoryCode,
                    state
                );
                break;
            case 'buttons':
                content = getActionNode(control, row);
                break;
            case 'createdAt':
            case 'updatedAt':
                content = getFormattedDate(row[control.id]);
                break;
            case 'createdAtDdMmYyyy':
            case 'updatedAtDdMmYyyy':
                content = getDateDDMMYYYY(row[control.id]);
                break;
            case 'alumniCreatedAndUpdated':
                content = (
                    <>
                        <span>Created on : {getFormattedDate(row['createdAt'])}</span>
                        <br />
                        <span>Updated on : {getFormattedDate(row['updatedAt'])}</span>
                    </>
                );
                break;
         case 'viewProfileMarkerLink':
                content = (
                    <>
                        <a
                        href="javascript:void(0)"
                        className="link" 
                        onClick={() => handleOpenLogsModal(row?.uuid,row?.schoolId)}
                        >View Markers</a>
                    </>
                );
                break;
           case 'profileMarkerAiStatus':
                content = <span>{getDomainValueForCode(row[control.id], control.props.domainCategoryCode, state)}</span>
                break;
            case 'networkAndPairingOne':
            case 'networkAndPairingTwo':
            case 'eventsAndCareerSupportOne':
            case 'eventsAndCareerSupportTwo':
                content = RowColumnBuilder(control.id, row);
                break;
            case 'userEnteredCollegeName':
                content = getUserEnteredInfo('COLLEGE', row['nonStandardInfoJson']);
                break;
            case 'userEnteredExamName':
                content = getUserEnteredInfo('EXAM', row['nonStandardInfoJson']);
                break;
            case 'total':
            case 'pendingValidation':
            case 'upToDate':
            case 'l1Due':
            case 'l2Due':
            case 'l3Due':
                content = getSchoolCountsWithLink(control.id, row);
                break;
            default:
                if (control.props?.domainCategoryCode?.length > 0)
                    content = getDomainValueForCode(row[control.id], control.props.domainCategoryCode, state);
                else content = row[control.id];
        }

        return (
            <td key={control.id} className={control.className}>
                {content}
            </td>
        );
    };

    const handlePerformAction = async (action: string, students: any) => {
        switch (action) {
            case 'DEACTIVATE':
                await deactivateAlumni(students);
                setSelectedRows([]);
                InternalAdminReportService.search(state.data.searchCriteria, state.routeInfo.pageName).then((response: any) => {
                    setStateValue('alumniList', response.data);
                    fetchAlumniCount(state);
                    toast.success('De-activated successfully');
                });
                break;
            case 'ACTIVATE':
                await activateAlumni(students);
                setSelectedRows([]);
                InternalAdminReportService.search(state.data.searchCriteria, state.routeInfo.pageName).then((response: any) => {
                    setStateValue('alumniList', response.data);
                    fetchAlumniCount(state);
                    toast.success('Activated successfully');
                });
                break;
            case 'VALIDATE':
                await validateAlumni(students);
                setSelectedRows([]);
                InternalAdminReportService.search(state.data.searchCriteria, state.routeInfo.pageName).then((response: any) => {
                    setStateValue('alumniList', response.data);
                    fetchAlumniCount(state);
                    toast.success('Validated successfully');
                });
                break;
            case 'VERIFY_EMAIL':
                    await verifyEmail(students);
                    setSelectedRows([]);
                    InternalAdminReportService.search(state.data.searchCriteria, state.routeInfo.pageName).then((response: any) => {
                        setStateValue('alumniList', response.data);
                        fetchAlumniCount(state);
                        toast.success('Email Verified successfully');
                    });
                    break;
            case 'AUTO_LOGIN':
                axiosClient()
                    .get(`${process.env.REACT_APP_COMMON_API}/users/get-user-hash/${students[0]?.uuid}/${students[0]?.schoolId}`)
                    .then((res: any) => {
                        const responseUserData = res.data as any;
                        if (responseUserData.success === true) {
                            // window.open(
                            //     `${process.env.REACT_APP_APP_BASE_URL}/sso/${responseUserData.data[0].user_hash}/cHJvZmlsZQ==`,
                            //     '_blank'
                            // );

                            const flexCol = getFlexColDomainValueForCode(students[0]?.schoolId, 'INSTITUTE_DOMAIN', state);
                            const whitelabel_url = isEmpty(flexCol) ? '' : JSON.parse(flexCol).whitelabel_url;
                            const baseUrl = !isEmpty(whitelabel_url) ? whitelabel_url : `${process.env.REACT_APP_APP_BASE_URL}/`;

                            const finalUrl = `${baseUrl}sso/${responseUserData.data[0].user_hash}/cHJvZmlsZQ==`;
                            window.open(finalUrl, '_blank');
                        }
                    })
                    .catch((err: any) => {
                        // Handle other errors
                        console.error(err);
                        alert('An error occurred while fetching details. Please try again later.');
                    });
                break;
            case 'ENGAGEMENT_API_RUN':
                toast.success('Your request has been sent successfully');
                axiosClient()
                    // .post(`https://ags-dev.univariety.in/hope/process/${students[0]?.uuid}`)
                    .post(`${process.env.REACT_APP_APP_BASE_URL}/hope/process/${students[0]?.uuid}`)
                    .then((res: any) => {
                        if (res.status === 200) {
                            console.log("responseUserData",res)
                            // toast.success('Engagement API Run Successfully');
                        }else{
                            console.log("responseUserData",res)
                        }
                    })
                    .catch((err: any) => {
                        // Handle other errors
                        console.error(err);
                        alert('An error occurred while fetching details. Please try again later.');
                    });
                break;
            case 'MARK_AS_RECRUITER':
                const finalUrl = `${process.env.REACT_APP_APP_BASE_URL}/alumni/${students[0].uuid}/recruiter-intent`;
                window.open(finalUrl, '_blank');
                break;
            case 'DELETE': {
                const selection = await confirmDeleteAlumniInstitute(students?.[0]?.uuid, students?.[0]?.schoolId);
                if (!selection) break;
                await deleteUser([{ uuid: selection.uuid, instituteId: selection.instituteId }]);
                setSelectedRows([]);
                InternalAdminReportService.search(state.data.searchCriteria, state.routeInfo.pageName).then((response: any) => {
                    setStateValue('alumniList', response.data);
                    fetchAlumniCount(state);
                    toast.success('Deleted successfully');
                });
                break;
            }
            case 'MARKED_AS_DECEASED': {
                const confirm = await Swal.fire({
                    title: 'Mark as Deceased?',
                    text: 'This will set the user as deceased and change their status to RAW_PROFILE.',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#d33',
                    cancelButtonColor: '#6c757d',
                    confirmButtonText: 'Yes, mark as deceased',
                    cancelButtonText: 'Cancel',
                });
                if (!confirm.isConfirmed) break;
                await markAsDeceased(students);
                setSelectedRows([]);
                InternalAdminReportService.search(state.data.searchCriteria, state.routeInfo.pageName).then((response: any) => {
                    setStateValue('alumniList', response.data);
                    fetchAlumniCount(state);
                    toast.success('Marked as deceased successfully');
                });
                break;
            }
        }
    };

    const fetchAlumniCount = async (state: any) => {
        try {
            const alumniCountData = await InternalAdminReportService.searchCount(state.data.searchCriteria, state.routeInfo.pageName);

            dispatch({
                type: 'SET_INTERNAL_STATE',
                payload: { key: 'alumniCount', value: alumniCountData?.data },
            });
        } catch (error) {
            console.error('Error fetching alumni count:', error);
        }
    };

    // const tableWidth = [250,180,180];
      const handleExportToExcel = async () => {
            try {
            const response =await InternalAdminReportService.profileMarkerExportToExcel(state.data.searchCriteria, state.routeInfo.pageName);
             const rawData = response.data;
             console.log("excel_length",rawData.length)
                    if (!rawData || !rawData.length) {
                        toast.error('No data returned from API to export.');
                        return;
                    }

                    ExportToExcelCommon(rawData, 'ProfileMarkerReport');

                } catch (error) {
                    console.error('Error fetching profile markers for export', error);
                    toast.error('Failed to fetch data for export.');
                }
      };
    
    const showStar = (row: any) => (row.isNotable && row.isNotable == 1 ? true : false);
    
    return (
        <div>
            <div className="ActiveListings_present">
                <div className="d-flex flex-wrap align-items-center mb-3 w-100 justify-content-between mailerLinks-parent">
                     {state.routeInfo.pageName === 'internal-admin-profile-marker' && (
                         <button className="btn btn-success" onClick={handleExportToExcel}>Export to Excel</button>
                     )}
                    <div className="d-flex flex-wrap align-items-center flex-1 mailerLinks my-2">
                        {config['BULK_ACTION'].length > 0 && (
                            <div className="d-flex justify-content-start align-items-center customselect_parnt">
                                <select
                                    name="complete Class 12"
                                    className="form-select w-120"
                                    onChange={(e) => setBulkAction(e.target.value)}>
                                    <option value={''}>Select</option>
                                    {config['BULK_ACTION'].map((action: string) => (
                                        <option key={action} value={action}>
                                            {getActionLabel(action)}
                                        </option>
                                    ))}
                                </select>
                                <button className="btn btn-darkblue" onClick={() => handlePerformAction(bulkAction, selectedRows)}>
                                    <span className="line-height-16">Apply</span>
                                </button>
                            </div>
                        )}
                    </div>
                    <ExportToExcel
                        rawData={allRowsData}
                        columns={InternalAdminReportService.getExportToExcelColumns(state.routeInfo.pageName)}
                        pageName={state.routeInfo.pageName}
                    />
                    <div className="d-flex flex-wrap align-items-center justify-content-end">
                        {/* <h3 className="font-14 font-500 mb-0 me-2">Total {allRowsData.length} records</h3> */}
                        {/* <h3 className="font-14 font-500 mb-0 me-2">Total {alumniCount && alumniCount[0]?.totalAlumni} records</h3> */}
                        <h3 className="font-14 font-500 mb-0 me-2">
                            Total {state?.internal?.alumniCount && state?.internal?.alumniCount[0]?.totalAlumni} records
                        </h3>
                    </div>
                </div>
                <div className="table-responsive attendee_dtl">
                    <table className={`table ${config.TABLE_CLASS}`} style={config.TABLE_STYLE}>
                        <thead>
                            <tr>
                                {resultsFormConfig.controlGroup.map((field: FormControl, index: number) => {
                                    if (evaluateExpression(field?.hideExpression, {...state?.data, userTypeCode: sessionState?.userTypeCode})) return null;

                                    return (
                                        <th
                                            key={field.props.label}
                                            style={config?.TABLE_WIDTH?.length > index ? { width: config?.TABLE_WIDTH[index] } : {}}>
                                            {!index && config['SHOW_SELECT_ALL'] && (
                                                <input
                                                    type="checkbox"
                                                    checked={selectedRows.length === allRowsData.length}
                                                    id="Antony"
                                                    className="form-check-input me-2 mt-0"
                                                    onChange={handleSelectAll}
                                                />
                                            )}
                                            {field.props.label}
                                        </th>
                                    );
                                })}
                            </tr>
                        </thead>
                        <tbody>
                            {pageData &&
                                pageData.map((row: any) => (
                                    <tr key={row?.uuid+''+row?.schoolId} className="">
                                        {resultsFormConfig.controlGroup.map((field: FormControl) => getFieldNode(field, row))}
                                    </tr>
                                ))}
                            {!pageData.length && (
                                <tr>
                                    {/* No data found message with image */}
                                    <td colSpan={resultsFormConfig.controlGroup.length} className="text-center">
                                        <div className="mt-20 max-700 mx-auto">
                                            <img className="mb-3 float_horizontal_animate mb-5" width="300" src="https://s3.ap-south-1.amazonaws.com/media.univariety.com/userreactapp/images/no-result-img-new.svg"/>
                                            {/* <h5 className="font-24 font-700">{noDataMessage}</h5> */}
                                            <p className="font-18 font-400 mb-4 py-2 px-0 px-md-2">{noDataSubMessage}</p>
                                        </div>
                                    </td>
                                </tr>
                            )}
                            <tr key="loadMoreRef" ref={loadMoreRef} />
                        </tbody>
                    </table>
                </div>
            </div>
            <ViewProfileMarkersLogs />
            {state.routeInfo?.pageName === 'inst-admin-grievance' && <GrievanceDetailPopUp id={grievanceDetailId} />}
        </div>
    );
};

export default Results;
